import { render, staticRenderFns } from "./pendingOsByType.vue?vue&type=template&id=53750cbc&scoped=true"
import script from "./pendingOsByType.vue?vue&type=script&lang=js"
export * from "./pendingOsByType.vue?vue&type=script&lang=js"
import style0 from "./pendingOsByType.vue?vue&type=style&index=0&id=53750cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53750cbc",
  null
  
)

export default component.exports